/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Redeem_BtnInputs */

const en_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redeem`)
};

const ar_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استبدال`)
};

const de_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einlösen`)
};

const es_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canjear`)
};

const fr_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échanger`)
};

const it_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscatta`)
};

const ja_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交換`)
};

const ko_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`교환`)
};

const pt_br_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resgatar`)
};

const ru_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обменять`)
};

const th_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แลกรับ`)
};

const tr_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al`)
};

const zh_cn_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`兑换`)
};

const zh_tw_redeem_btn = /** @type {(inputs: Redeem_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`兌換`)
};

/**
* | output |
* | --- |
* | "Redeem" |
*
* @param {Redeem_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const redeem_btn = /** @type {((inputs?: Redeem_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Redeem_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_redeem_btn(inputs)
	if (locale === "ar") return ar_redeem_btn(inputs)
	if (locale === "de") return de_redeem_btn(inputs)
	if (locale === "es") return es_redeem_btn(inputs)
	if (locale === "fr") return fr_redeem_btn(inputs)
	if (locale === "it") return it_redeem_btn(inputs)
	if (locale === "ja") return ja_redeem_btn(inputs)
	if (locale === "ko") return ko_redeem_btn(inputs)
	if (locale === "pt_br") return pt_br_redeem_btn(inputs)
	if (locale === "ru") return ru_redeem_btn(inputs)
	if (locale === "th") return th_redeem_btn(inputs)
	if (locale === "tr") return tr_redeem_btn(inputs)
	if (locale === "zh_cn") return zh_cn_redeem_btn(inputs)
	return zh_tw_redeem_btn(inputs)
});